<main class="flex-shrink-0">
  <div class="container mw-100 d-flex flex-column align-items-center mx-0">
    <h2 class="m-8" i18n="@@HowToHelpHeader">Wie können wir Ihnen helfen?</h2>

    <div class="card p-4 bg-white d-flex justify-content-center">
      <h5 class="mb-0" i18n="@@ContactUsHeader">
        Kontaktieren Sie uns
      </h5>
      <div class="mt-4" i18n="@@ContactUsText">
        Wenn Sie Fragen haben, zum Beispiel zur Funktionalität der Software, wenden Sie sich gerne von
        <strong class="d-block py-2 pl-4">Montag bis Freitag zwischen 9 und 17 Uhr</strong>
        an unser Support Team oder nutzen Sie das Kontaktformular.
      </div>
      <div class="d-flex gap-3 mt-4">
        <p>
          <app-svg source="icons/feather/mail" height="18"></app-svg>&nbsp;<span><a class="ms-2" style="text-decoration: none" href="mailto:support@mycubos.com">support@cubos.com</a></span>
        </p>
        <p>
          <app-svg source="icons/feather/phone" height="18"></app-svg>&nbsp;<span><a class="ms-2" style="text-decoration: none" href="tel:+49530852112255">+49 (0)53 08 – 52 11 22 55</a></span>
        </p>
      </div>
      <div class="mt-4">
        <form class="container-fluid" [formGroup]="formService.form" autocomplete="off" novalidate (ngSubmit)="sendMessageToSupport(formService.form.value)" *ngIf="formCreated">
          <div class="form-group position-relative">
            <label for="subject" i18n="@@SubjectLabel">Betreff*</label>
            <div class="mb-3">
              <select id="subject" formControlName="subject" class="form-control form-select" aria-label="Betreff">
                <option value="" selected disabled i18n="@@PleaseChooseSubjectPlaceholder">bitte Betreff wählen...</option>
                <option value="software" i18n="@@GeneralSoftwareOption">Allgemeine Fragen zur Software</option>
                <option value="bug" i18n="@@SubscriptionOption">Fehler gefunden</option>
                <option value="reOrderRfid" i18n="@@ReOrderRfidOption">Nachbestellung von RFID-Karten</option>
              </select>
              <div class="error">
                <em *ngIf="formService.validateControl('subject') && formService.hasError('subject', 'required')" i18n="@@SubjectRequiredError">
                  Betreff wird benötigt
                </em>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="message" i18n="@@YourMessagesLabel">Ihre Nachricht*</label>
            <textarea id="message" formControlName="message" rows="5" class="form-control" i18n-placeholder="@@YourMessagesPlaceholder" placeholder="Ihre Nachricht*"></textarea>
            <div class="error">
              <em *ngIf="formService.validateControl('message') && formService.hasError('message', 'required')" i18n="@@MessageRequiredError">
                Nachricht wird benötigt
              </em>
            </div>
          </div>
          <!-- <div class="form-inline position-relative">
            <label for="contactMe" class="nested" i18n="@@ContactMeLabel">
              <input type="checkbox" id="contactMe" formControlName="contactMe" class="me-1 form-check-input" />
              Kontaktieren Sie mich
            </label>                      
          </div>   -->
          <div class="float-end">
          <button type="submit" id="submit_support" class="btn btn-yellow" [disabled]="!formService.form.valid">
            <app-svg source="icons/feather/send" height="18"></app-svg>
            <span i18n="@@ContactSupport">&ensp;Kontakt aufnehmen</span>
          </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
